export const numbersOnly = val => {
  return typeof val === 'string' ? val && val.replace(/[^0-9]/g, '') : ''
}

export const numberNoDecimals = (val = '0') => {
  if (typeof val !== 'string') {
    return '0'
  }
  return numbersOnly(
    val.includes('.') ? val.substring(0, val.lastIndexOf('.')) : val
  )
}

export const numberWithDecimals = val => {
  return typeof val === 'string' ? val && val.replace(/[^0-9.]/g, '') : ''
}
